// PROJECT DISCONTINUE

import React, { Component } from 'react';

import ic_cancel from '../resources/cancel_circle.png';
import ic_search from '../resources/baseline_search.png';

var request = require('../../utilities/NetworkRequest');
var cache_util = require('../../utilities/CacheUtil');

export default class ProductSearchDialog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      search_by_id: '',
      search_by_name: '',
      products: [],
      is_loading: false,
      selected_index: -1,
      is_admin: false
    };
    this.search_timeout = null;
  }

  componentDidMount() {
    this.searchByIdInput.focus();
    // Determine if the current user is admin (TP9999) — admin dapat filter produk per-grosir
    const user_info = cache_util.onGetCacheData(cache_util.CACHE_INFO).result.user_information;
    this.setState({
      is_admin: user_info.wholesaler_id === 'TP9999'
    });
  }

  onSearchByIdChange(e) {
    const text = e.target.value;
    this.setState({ search_by_id: text, selected_index: -1 });

    if (this.search_timeout) {
      clearTimeout(this.search_timeout);
    }

    this.search_timeout = setTimeout(() => {
      this.searchProducts();
    }, 300);
  }

  onSearchByNameChange(e) {
    const text = e.target.value;
    this.setState({ search_by_name: text, selected_index: -1 });

    if (this.search_timeout) {
      clearTimeout(this.search_timeout);
    }

    this.search_timeout = setTimeout(() => {
      this.searchProducts();
    }, 300);
  }

  searchProducts() {
    const { search_by_id, search_by_name, is_admin } = this.state;

    if (!search_by_id.trim() && !search_by_name.trim()) {
      this.setState({ products: [] });
      return;
    }

    this.setState({ is_loading: true }, () => {
      // Get user information from cache (same as Product.js)
      let user_info = cache_util.onGetCacheData(cache_util.CACHE_INFO).result.user_information;

      // User biasa selalu kirim wholesaler_id sendiri.
      const wholesalerIdToSend = user_info.wholesaler_id;

      // Admin (TP9999) bisa filter IN (kode_grosir1, kode_grosir2, ...) dari Daftar Grosir.
      // Sumber: props.wholesaler_ids (di-pass dari bundle dialog).
      const wholesalerIdsFromProps = Array.isArray(this.props.wholesaler_ids)
        ? this.props.wholesaler_ids.filter(id => id && String(id).trim() !== '')
        : [];

      // Build body for API - match what backend expects
      // retail_id can be empty string for web monitoring, but query needs a value
      let body = {
        wholesaler_id: wholesalerIdToSend,
        // Backend expects JSON-stringified array untuk IN (...) filter (admin only)
        wholesaler_ids: (is_admin && wholesalerIdsFromProps.length > 0)
          ? JSON.stringify(wholesalerIdsFromProps)
          : null,
        retail_id: user_info.retail_id || 'WEB_USER',
        size: 50,
        page: 1,
        text: search_by_name.trim() || '',
        pcode: search_by_id.trim() || '',
        is_new: 'null',
        is_promo: 'null',
        is_favourite: 'null',
        isCategoryNeeded: '0',
        view_id: '/show/products/details'
      };

      // Build filter array based on search inputs
      const filter = [];
      if (search_by_id.trim()) {
        filter.push({
          type: 'input_free_text',
          key: 'product.pcode',
          description: 'Product ID',
          value: search_by_id.trim()
        });
      }
      if (search_by_name.trim()) {
        filter.push({
          type: 'input_free_text',
          key: 'product.pcode_name',
          description: 'Nama Produk',
          value: search_by_name.trim()
        });
      }
      body.filter = JSON.stringify(filter);

      // Use /show/products/details for promo bundle (returns sellingPrice and img_tiny)
      request.onRequestData(request.OPTION_API_MAIN, '/show/products/details', body, (res_data) => {
        if (res_data.code === 1) {
          // Map API response fields to frontend expected fields
          const mappedProducts = (res_data.result.product || []).map(product => {
            // Pilih entry price_level: prioritaskan uom_type 'small' dengan quantity terkecil.
// Unit (uom) & harga keduanya diambil dari entry yang sama agar konsisten di UI.
            let uomText = '';
            let uomId = '';
            let productPrice = 0;
            let selectedPriceLevel = null;

            if (product.price_level && product.price_level.length > 0) {
              const smallUoms = product.price_level.filter(pl => pl.uom_type === 'small');
              if (smallUoms.length > 0) {
                // Ambil yang quantity terkecil dari kandidat 'small'
                selectedPriceLevel = smallUoms.reduce((min, current) =>
                  (parseFloat(current.quantity) < parseFloat(min.quantity)) ? current : min
                );
              } else {
                // Fallback ke item pertama jika tidak ada 'small'
                selectedPriceLevel = product.price_level[0];
              }
              productPrice = parseInt(selectedPriceLevel.price) || 0;
              // UOM diambil dari price_level agar konsisten dengan harga
              uomText = selectedPriceLevel.uom || '';
            } else if (product.unit_level && product.unit_level.length > 0) {
              // Fallback ke unit_level jika price_level tidak tersedia
              if (product.unit_level.length > 1) {
                uomText = product.unit_level[1].text || product.unit_level[0].text || '';
              } else {
                uomText = product.unit_level[0].text || '';
              }
              uomId = product.unit_level[0].id || '';
            }

            // Fallback harga jika price_level kosong / tidak valid
            if (!productPrice) {
              if (product.sellingPrice) {
                productPrice = product.sellingPrice;
              } else if (product.price) {
                productPrice = product.price;
              }
            }
            return {
              ...product,
              pcode: product.product_id || product.pcode,
              pcode_name: product.name || product.pcode_name,
              cat_a: product.category_id || product.cat_a,
              imgtiny_url: product.img_tiny || product.imgtiny_url,
              uom_a: uomText || product.uom_a || product.uom_b || '',
              uom_b_mst: uomId || product.uom_b || product.uom || product.uom_a || '',
              price: productPrice,
              sellingPrice: productPrice,
              price_level: product.price_level,
            };
          });
          this.setState({
            products: mappedProducts,
            is_loading: false
          });
        } else {
          this.setState({ products: [], is_loading: false });
        }
      });
    });
  }

  onKeyDown(e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      this.setState(prev => ({
        selected_index: Math.min(prev.selected_index + 1, prev.products.length - 1)
      }));
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      this.setState(prev => ({
        selected_index: Math.max(prev.selected_index - 1, -1)
      }));
    } else if (e.key === 'Enter' && this.state.selected_index >= 0) {
      e.preventDefault();
      this.onSelectProduct(this.state.products[this.state.selected_index]);
    } else if (e.key === 'Escape') {
      this.props.onCloseListener('close', null);
    }
  }

  onSelectProduct(product) {
    this.props.onCloseListener('select', product);
  }

  render() {
    const { search_by_id, search_by_name, products, is_loading, selected_index, is_admin } = this.state;
    const wholesalerIdsFromProps = Array.isArray(this.props.wholesaler_ids)
      ? this.props.wholesaler_ids.filter(id => id && String(id).trim() !== '')
      : [];

    return (
      <div onClick={(e) => this.props.onCloseListener('close', null)} className='process_dialog_root layer_a'>
        <div onClick={(e) => e.stopPropagation()} className='process_dialog_container' style={{ width: 550, maxHeight: 500 }}>
          {/* Header */}
          <div className='title_search_container blue_background'>
            <div className='full_flex default_text_medium_white bold_text'>Cari Produk</div>
            <img onClick={(e) => this.props.onCloseListener('close', null)} className='custom_cursor_a mini_image_c' src={ic_cancel} alt='' />
          </div>

          {/* Search Inputs */}
          <div style={{ padding: 15, borderBottom: '1px solid #eee' }}>
            {/* Kode Grosir — hanya untuk admin (TP9999), auto-populated dari Daftar Grosir */}
            {is_admin && (
              <div style={{ marginBottom: 10 }}>
                <div className='default_text_normal_gray' style={{ marginBottom: 4, fontSize: 12 }}>Kode Grosir</div>
                {wholesalerIdsFromProps.length > 0 ? (
                  <div
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      border: '1px solid #ddd',
                      borderRadius: 4,
                      backgroundColor: '#f5f5f5',
                      color: '#666',
                      fontSize: 13
                    }}
                    className='default_text_normal_gray non_transparent_input'
                  >
                    {wholesalerIdsFromProps.join(', ')}
                  </div>
                ) : (
                  <div
                    style={{
                      width: '100%',
                      padding: '8px 10px',
                      border: '1px dashed #ccc',
                      borderRadius: 4,
                      backgroundColor: '#fafafa',
                      color: '#999',
                      fontSize: 12,
                      fontStyle: 'italic'
                    }}
                  >
                    Belum ada grosir dipilih. Tambahkan kode grosir di Daftar Grosir terlebih dahulu.
                  </div>
                )}
                <div className='default_text_normal_gray' style={{ marginTop: 4, fontSize: 11, color: '#888' }}>
                  {wholesalerIdsFromProps.length > 0
                    ? `Akan memfilter produk dari ${wholesalerIdsFromProps.length} grosir (sumber: Daftar Grosir)`
                    : 'Filter produk otomatis mengikuti Daftar Grosir di form bundle.'}
                </div>
              </div>
            )}
            <div style={{ marginBottom: 10 }}>
              <div className='default_text_normal_gray' style={{ marginBottom: 4, fontSize: 12 }}>By Product ID</div>
              <div style={{ position: 'relative' }}>
                <input
                  ref={(input) => { this.searchByIdInput = input; }}
                  type='text'
                  value={search_by_id}
                  onChange={(e) => this.onSearchByIdChange(e)}
                  onKeyDown={(e) => this.onKeyDown(e)}
                  placeholder='Ketik Product ID...'
                  style={{ width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 4 }}
                  className='default_text_normal_gray non_transparent_input'
                />
              </div>
            </div>
            <div>
              <div className='default_text_normal_gray' style={{ marginBottom: 4, fontSize: 12 }}>By Nama Produk</div>
              <div style={{ position: 'relative' }}>
                <img src={ic_search} alt='' style={{ position: 'absolute', left: 10, top: 10, width: 16, height: 16, opacity: 0.5 }} />
                <input
                  type='text'
                  value={search_by_name}
                  onChange={(e) => this.onSearchByNameChange(e)}
                  onKeyDown={(e) => this.onKeyDown(e)}
                  placeholder='Ketik Nama Produk...'
                  style={{ width: '100%', padding: '8px 10px', border: '1px solid #ddd', borderRadius: 4 }}
                  className='default_text_normal_gray non_transparent_input'
                />
              </div>
            </div>
          </div>

          {/* Loading */}
          {is_loading && (
            <div style={{ padding: 20, textAlign: 'center' }}>
              <span className='default_text_normal_gray'>Mencari produk...</span>
            </div>
          )}

          {/* Results */}
          <div style={{ maxHeight: 350, overflow: 'auto' }}>
            {!is_loading && products.length === 0 && (search_by_id.length > 0 || search_by_name.length > 0) && (
              <div style={{ padding: 30, textAlign: 'center', color: '#999' }}>
                Produk tidak ditemukan
              </div>
            )}

            {!is_loading && products.length === 0 && search_by_id.length === 0 && search_by_name.length === 0 && (
              <div style={{ padding: 30, textAlign: 'center', color: '#999' }}>
                Ketik Product ID atau Nama Produk untuk mencari
              </div>
            )}

            {products.map((product, index) => (
              <div
                key={index}
                onClick={() => this.onSelectProduct(product)}
                onMouseEnter={() => this.setState({ selected_index: index })}
                style={{
                  padding: '12px 15px',
                  borderBottom: '1px solid #f0f0f0',
                  cursor: 'pointer',
                  backgroundColor: selected_index === index ? '#e3f2fd' : 'transparent'
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  {/* Product Image */}
                  {product.imgtiny_url ? (
                    <img
                      src={product.imgtiny_url}
                      alt={product.pcode_name}
                      style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid #eee' }}
                    />
                  ) : (
                    <div style={{ width: 40, height: 40, backgroundColor: '#f5f5f5', borderRadius: 4, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span style={{ fontSize: 10, color: '#999' }}>NoImg</span>
                    </div>
                  )}
                  <div style={{ flex: 1 }}>
                    <div className='default_text_normal_gray bold_text'>{product.pcode_name}</div>
                    <div className='default_text_normal_gray' style={{ fontSize: 11, marginTop: 2 }}>
                      <span style={{ marginRight: 10 }}>ID: {product.pcode}</span>
                      <span>Group: {product.cat_a || '-'}</span>
                    </div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div className='default_text_normal_gray' style={{ fontSize: 11 }}>
                      {product.uom_a || '-'}
                    </div>
                    {(product.sellingPrice || product.price) && (
                      <div className='default_text_normal_gray bold_text' style={{ fontSize: 12, marginTop: 2, color: '#2e7d32' }}>
                        {new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(product.sellingPrice || product.price)}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Footer hint */}
          <div style={{ padding: '8px 15px', backgroundColor: '#f5f5f5', borderTop: '1px solid #eee', fontSize: 11, color: '#999' }}>
            Tekan ↑↓ untuk navigasi, Enter untuk pilih, Esc untuk tutup
          </div>
        </div>
      </div>
    );
  }

}